/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { filteredOptions } from 'src/core/helpers'
import styles from './ProposalFormContent.module.scss'
import { Divider, Button, Row, FormInstance } from 'antd'
import { proposalFormSections } from './proposal-form.sections'
import { CustomTitle, CustomText, CustomCol } from 'src/components'
import {
  sendRequestForProposalSelector,
  projectOptionListSelector,
  currencyListSelector,
  countryListSelector,
} from 'src/features'

const ProposalFormContent: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { t } = useTranslation()
  const [projectTypeSelected, setProjectTypeSelected] = useState(null)
  const currencyList = useAppSelector(currencyListSelector)
  const { loading: loadingRequest } = useAppSelector(sendRequestForProposalSelector)
  const { data: projectOptions } = useAppSelector(projectOptionListSelector)
  const countryList = useAppSelector(countryListSelector)

  const fieldState = !projectTypeSelected ? 'COMPENSATION' : projectTypeSelected === 'compensation' ? 'COMPENSATION' : 'ENERGY'

  const fields = {
    COMPENSATION: {
      standardList: filteredOptions(projectOptions, 'standard'),
      typeList: filteredOptions(projectOptions, 'type'),
      measure: 'tCO₂'
    },
    ENERGY: {
      standardList: filteredOptions(projectOptions, 'standard_energy_type'),
      typeList: filteredOptions(projectOptions, 'energy_source_type'),
      measure: 'MWh'
    }
  }[fieldState]

  const handleProjectTypeChange = (value: string) => {
    setProjectTypeSelected(value)
    if (value) { form.resetFields(['standards', 'types']) }
  }

  const formSections = proposalFormSections(
    t, fields.standardList, fields.typeList, countryList,
    styles, currencyList, fields.measure, handleProjectTypeChange
  )

  return <div className='fade-animation'>
    <CustomTitle label={t('RequestProposal.BigLabel')} type='secondary'/>
    <br/>
    <CustomTitle label={t('RequestProposal.SubLabel')} type={null}  />
    <Divider />
    {/* Form Sections */}
    {formSections.map((section, idx) => (
      <div key={idx}>
        {!section.isRow ? <>
          {section.addBr && <><br/></>}
          <section.formComponent {...section.formProps}>
            {section.formChildren}
          </section.formComponent>
          <CustomText label={section.downLabel} type={'secondary'} className={styles.textMargin}/>
        </>: <>
          {!section.formChildren ? <>
            <Row>
              <CustomCol className='mt-4'>
                <CustomText label={section.leftLabel} type='secondary'/>
              </CustomCol>
              <CustomCol>
                <section.formComponent {...section.formProps}/>
              </CustomCol>
            </Row>
          </> : <>
            <Row>
              <CustomCol className='mt-4'>
                <CustomText label={section.leftLabel} type='secondary'/>
              </CustomCol>
              <CustomCol>
                <section.formComponent {...section.formProps}>
                  {section.formChildren}
                </section.formComponent>
              </CustomCol>
            </Row>
          </>}
        </>}
      </div>
    ))}

    {/* Button Content */}
    <Button
      block
      size='large'
      type='primary'
      htmlType='submit'
      className='radius-100 mt-2'
      loading={loadingRequest}
    >{loadingRequest ? t('RequestProposal.Sending') : t('RequestProposal.Send')}
    </Button>
  </div>
}

export default ProposalFormContent
